import { AuthProvider } from "@pankod/refine-core";

import { supabaseClient } from "utility";

const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const { user, error } = await supabaseClient.auth.signIn({
      email: username,
      password,
    });

    if (error) {
      return Promise.reject(error);
    }

    if (user) {
      if (user.user_metadata?.role === "agent") {
        const err = { message: "403 Forbidden",
          status: 403
        };
        return Promise.reject(err);
      }
      return Promise.resolve();
    }
  },
  logout: async () => {
    const { error } = await supabaseClient.auth.signOut();

    if (error) {
      return Promise.reject(error);
    }

    return Promise.resolve("/");
  },
  checkError: () => Promise.resolve(),
  checkAuth: () => {
    const session = supabaseClient.auth.session();

    if (session) {
      return Promise.resolve();
    }

    return Promise.reject();
  },
  getPermissions: async () => {
    const user = supabaseClient.auth.user();
    
    if (user) {
      if (user.role === "agent") {
        const err = { message: "403 Forbidden",
          status: 403
        };
        return Promise.reject(err);
      }
      return Promise.resolve(user.role);
    }
  },
  getUserIdentity: async () => {
    const user = supabaseClient.auth.user();

    if (user) {
      return Promise.resolve({
        ...user,
        name: user.email,
      });
    }
  },
};

export default authProvider;

// https://getavataaars.com/?avatarStyle=Circle
// <Avatar
//   avatarStyle='Circle'
//   topType='LongHairStraight'
//   accessoriesType='Blank'
//   hairColor='BrownDark'
//   facialHairType='Blank'
//   clotheType='BlazerShirt'
//   eyeType='Default'
//   eyebrowType='Default'
//   mouthType='Default'
//   skinColor='Light'
// />

/**
 * Returns a hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
// function hashCode(str: string) {
//   let hash = 0;
//   for (let i = 0, len = str.length; i < len; i++) {
//     let chr = str.charCodeAt(i);
//     hash = (hash << 5) - hash + chr;
//     hash |= 0; // Convert to 32bit integer
//   }
//   return hash;
// }

// export const TOKEN_KEY = "refine-auth";

// export const authProvider: AuthProvider = {
//     login: async ({ username, password }) => {
//         const token = hashCode(`${username}-${password}`);
//         localStorage.setItem(TOKEN_KEY, `${token}`);
//         // localStorage.setItem(TOKEN_KEY, `${username}-${password}`);
//         return Promise.resolve();
//     },
//     logout: () => {
//         localStorage.removeItem(TOKEN_KEY);
//         return Promise.resolve();
//     },
//     checkError: () => Promise.resolve(),
//     checkAuth: () => {
//         const token = localStorage.getItem(TOKEN_KEY);
//         const myToken = hashCode('admin-Q7sbHzPS0BBK');
//         const myTokenStr = `${myToken}`;
//         if (token === myTokenStr) {
//             return Promise.resolve();
//         }

//         return Promise.reject();
//     },
//     getPermissions: () => Promise.resolve(),
//     getUserIdentity: async () => {
//         const token = localStorage.getItem(TOKEN_KEY);
//         if (!token) {
//             return Promise.reject();
//         }

//         return Promise.resolve({
//             id: 1,
//             name: "Admin Noname",
//             avatar: "https://i.pravatar.cc/150",
//         });
//     },
// };